import React from "react";
// import images from "../../../Assets/Images/Image/News/Bg (8).webp";
import css from "../../../Assets/Styles/Home/blog.module.css";
import { Link } from "react-router-dom";
import Blog from "./Blogs";

const OurLatestBlog = () => {
  return (
    <section className=" max-w-full my-28 2xl:max-w-[1300px] mx-auto max-xl:max-w-[1100px]">
      <div className="text-center">
        <button className="custom_button2 mx-auto">
          <span>~ Our Latest Blog ~</span>
        </button>
        <h2 className=" mb-[28px] leading-[38px] uppercase  max-sm:leading-[1.1428] text-[#1E1B18] font-fira font-bold text-[25px] max-sm:text-[42px]">
          latest blog and article
        </h2>
      </div>

      <div className="flex justify-center mt-[69px] gap-[50px] 2xl:flex-row flex-col ">
        <aside className="max-lg:w-[30%] max-lg:block  hidden max-lg:mx-auto">
          <div className={css.blogAside}>
            <div className="text-center p-5">
              <h4 className="text-3xl text-[#ffffff] font-fira font-bold mb-10 capitalize">
                Get started with your free estimate.
              </h4>
              <Link to="/blog">
                <button className="w-[172px] h-[58px] bg-[#ffffff] font-bold text-[#0D1C37]">
                  Started Now <i className="fa-solid fa-arrow-right ml-2"></i>
                </button>
              </Link>
            </div>
          </div>
        </aside>
        <article className=" w-full px-3 max-sm:px-10  max-lg:px-0  max-lg:w-[70%] max-lg:mx-auto relative">
          <Blog />
        </article>
      </div>
    </section>
  );
};

export default OurLatestBlog;
